/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IDictionaryItem } from '../../api/types';

import genericReducers from '../genericReducer';
import { GET_SETTINGS_SECTIONS } from '../../actions';

import { IReducers } from '..';

export type SettingSectionsState = ICommonResponse<IDictionaryItem>;

const initialState = {
  content: [],
  loading: false,
} as ICommonResponse<IDictionaryItem>;
const generic = genericReducers<SettingSectionsState>();
const settingSections: IReducers<SettingSectionsState> = {
  [GET_SETTINGS_SECTIONS[REQUEST]]: generic.get.request,
  [GET_SETTINGS_SECTIONS[SUCCESS]]: generic.get.success,
  [GET_SETTINGS_SECTIONS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, settingSections);
